import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { window } from "@swa-ui/browser";
import { Button } from "@swa-ui/core";
import { encryptData, EncryptionContext } from "@swa-ui/encryption";

import { OJT_MANAGE_BOOKINGS_URL } from "../defines";
import { useOJTWebappUrl } from "../useOJTWebappUrl";
import { getPersistedVacationsBookingData } from "../vacationsPersistence";

export const ManageMyVacationCallToAction = (props) => {
  const { ariaLabel, buttonType, children } = props;
  const { encrypt } = useContext(EncryptionContext);
  const OJTBaseUrl = useOJTWebappUrl();
  const urlData = getBootstrapData("urls");

  useEffect(() => {
    const data = getPersistedVacationsBookingData() || {};

    if (!Object.keys(data)?.length) {
      window.location.assign(urlData.AIR_VIEW_RESERVATION);
    }
  }, []);

  return <Button {...getProps()}>{children}</Button>;

  function getProps() {
    return {
      "aria-label": ariaLabel,
      onClick: handleClick,
      styleType: buttonType,
    };
  }

  async function handleClick() {
    const { getawaysConfirmationNumber, passengerFirstName, passengerLastName } =
      getPersistedVacationsBookingData();
    const formDataToEncrypt = {
      bookingReference: getawaysConfirmationNumber,
      firstName: passengerFirstName,
      surname: passengerLastName,
    };
    const ojtManageBookingsPage = `${OJTBaseUrl}${OJT_MANAGE_BOOKINGS_URL}`;

    const url = await encryptData(
      encrypt,
      formDataToEncrypt,
      ojtManageBookingsPage,
      "ManageMyVacationCallToAction",
      "vacationManageMyBookings",
      "booking"
    );

    window.location.assign(url);
  }
};

ManageMyVacationCallToAction.propTypes = {
  /** Mapped to aria-label of Button or Link component. */
  ariaLabel: PropTypes.string,

  /**
   * Mapped to styleType of Button component.
   * Standard Buttons will have 'primary' or 'button-primary' semantic values, while
   * buttonType with link values 'bright'/'dark'/'light' should render a Link.
   */
  buttonType: PropTypes.string,

  /** Content that will be rendered on the Button or Link component. */
  children: PropTypes.node,
};
